let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6gtWo")).then(() => parcelRequire('62WCn'));